import { IMenuListLink } from '../../molecules/menu-list/menu-list';
import { IAdditiveFilterModel } from '../../organisms/additive-filter/additive-filter';
import t from '../../../labels/labelling-utils';
import { IMatch } from '../../../typings/match';
import { isEnded, isLive, isPreMatch } from '../../../utils/match-status';

import { ICompetition, IMatchRound } from './football-live-score';

export const filterDays: IMenuListLink[] = [
  { label: t('previous-day-filter') },
  { label: t('current-day-filter') },
  { label: t('next-day-filter') },
];

export const statusFilterModel: IAdditiveFilterModel[] = [
  { name: t('filter-all') },
  { name: t('tennis.match.status.live') },
  { name: t('filter-ended') },
  { name: t('tennis.match.status.scheduled') },
];

export const getMatchListFiltered = (filteredList: ICompetition[], selectedStatusIndex: number): IMatch[][][] =>
  filteredList.map((competition: ICompetition) => {
    const { matchRoundList } = competition;
    return matchRoundList.length > 0
      ? matchRoundList.map((matchRound: IMatchRound) => {
          const matchList: IMatch[] = matchRound.matchDayList[0].matchList ?? [];
          return filterMatchList(matchList, selectedStatusIndex);
        })
      : [];
  });

export const filterMatchList = (matchList: IMatch[], selectedStatusIndex: number) => {
  return matchList.filter((match: IMatch) => {
    switch (selectedStatusIndex) {
      case 1:
        return isLive(match.status);
      case 2:
        return isEnded(match.status);
      case 3:
        return isPreMatch(match.status);
      default:
        return Boolean(match);
    }
  });
};
